<template>
  <canvas 
    ref="chartCanvas" 
    :style="chartSize" >
  </canvas>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, LineElement, PointElement, LinearScale, CategoryScale, BarController, LineController, Filler, Decimation, ArcElement } from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,   
  BarElement,    
  PointElement,
  LinearScale,    
  CategoryScale,
  BarController, 
  LineController, 
  Filler,
  Decimation,
  ArcElement
);

export default {
  name: 'DynamicChartComponent',
  props: {
    chartType: {
      type: String,
      required: true,
      validator: value => ['Bar', 'Line'].includes(value)  // 현재 'Bar' 또는 'Line'만 허용
    },
    chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      required: true
    },
    chartSize: {
      type: Object,
      required: true
    },
  },
  watch: {
    chartData: {
      handler(newValue, oldValue) {
        //캔버스가 아직 렌더링되지 않았다면 100ms 후 재시도
        if (!this.$refs.chartCanvas) {
          // console.warn("chartCanvas가 아직 렌더링되지 않음. 100ms 후 다시 시도.");
          setTimeout(() => {
            if (this.$refs.chartCanvas) {
              this.renderChart();
            }
          }, 100);
          return;
        }

        if (this.chartInstance) {
          // console.log(차트 데이터 업데이트 update() 호출");
          this.chartInstance.data = newValue;
          this.chartInstance.update();
        } else {
          this.renderChart();
        }
      },
      deep: true,
      immediate: true 
    },
    chartOptions: {
      handler(newValue, oldValue) {
        // 옵션이 바뀌었을 때만 차트를 다시 그리기
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.renderChart();
        }
      },
      deep: true
    }
  },
  data() {
    return {
      chartInstance: null
    };
  },
  mounted() {
    // console.log("마운트");

    // chartData가 초기값으로 존재할 경우 바로 차트 렌더링
    if (this.chartData && this.chartData.datasets && this.chartData.datasets.length > 0) {
      this.renderChart();
    }
  },
  beforeUnmount() {
    this.destroyChart(); // 컴포넌트가 파괴되기 전에 차트 인스턴스를 제거
  },
  methods: {
    renderChart() {
      if (!this.chartData || !this.chartData.datasets || this.chartData.datasets.length === 0) {
        // console.warn("chartData가 비어 있음:", JSON.stringify(this.chartData, null, 2));
        return;
      }

      // 기존 차트 제거
      const existingChart = ChartJS.getChart(this.$refs.chartCanvas);
      if (existingChart) {
        existingChart.destroy();
      }

      const ctx = this.$refs.chartCanvas.getContext("2d");
      this.chartInstance = new ChartJS(ctx, {
        type: this.chartType.toLowerCase(),
        data: this.chartData,
        options: this.chartOptions,
      });
    },
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
  }
};
</script>